import { useContext } from 'react'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { PlusIcon } from '@heroicons/react/24/outline'

export default function AddExerciseButton({ 
    exerciseCollection = {},
    setExerciseCollection = () => {},
    insertIndex = 0 
}) {

    const { ShowModal } = useContext(ModalContext)

    const OnAddExerciseToCollectionButton = () => {
        const modalData = {
            key: ModalKey.ExerciseLibrary,
            size: 'third',
            subHeaderText: 'Select an exercise to add to the collection',
            OnExerciseSelected: (exercise) => __InsertExerciseIntoCollection(insertIndex, exercise)
        }

        ShowModal(modalData)
    }

    const __InsertExerciseIntoCollection = (insertIndex, exercise) => {
        if (exerciseCollection.type === 'pool') {
            const newExerciseCollectionJSONItem = {
                "exerciseId": exercise.id
            }

            setExerciseCollection(prev => {
                const updatedJSON = [...prev.exerciseCollectionCycles]
                updatedJSON.splice(insertIndex, 0, newExerciseCollectionJSONItem)
                return { ...prev, exerciseCollectionCycles: updatedJSON }
            })
        }

        if (exerciseCollection.type === 'progression') {
            const newExerciseCollectionJSONItem = {
                "cyclesCompleted": 0,
                "cyclesAssigned": 1,
                "exerciseCollectionCycleExercises": [
                    {
                        "exerciseId": exercise.id,
                        "occurrencesCompleted": 0,
                        "occurrencesAssigned": 1
                    }
                ]
            }

            setExerciseCollection(prev => {
                const updatedJSON = [...prev.exerciseCollectionCycles]
                updatedJSON.splice(insertIndex, 0, newExerciseCollectionJSONItem)
                return { ...prev, exerciseCollectionCycles: updatedJSON }
            })
        }
    }

    return (
        <div 
            className="w-40 self-stretch h-auto border border-gray-400 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-100"
            onClick={() => OnAddExerciseToCollectionButton(insertIndex)}
        >
            <PlusIcon className="h-10 w-10 text-gray-400" />
        </div>
    )
}